// Import bootstrap
import * as bootstrap from 'bootstrap';

// Import our SCSS
import '../scss/main.scss';

// Your custom JavaScript here

// Update URL hash when a Bootstrap tab is activated
document.addEventListener('DOMContentLoaded', function () {
  const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');

  const dropdownLinkToggles = document.querySelectorAll(
    'a.js-space-dropdown-toggle[data-bs-toggle="dropdown"]',
  );
  // Activate tab from hash on page load
  if (window.location.hash) {
    const hash = window.location.hash.replace('#', '');
    const tabToShow = document.getElementById(hash);
    if (tabToShow && tabToShow.getAttribute('data-bs-toggle') === 'tab') {
      const tabInstance = bootstrap.Tab.getOrCreateInstance(tabToShow);
      tabInstance.show();
    }
  }

  tabLinks.forEach(function (tab) {
    tab.addEventListener('shown.bs.tab', function (event) {
      if (event.target && event.target.id) {
        // Update the hash in the URL bar
        history.replaceState(null, '', '#' + event.target.id);
      }
    });
  });

  dropdownLinkToggles.forEach(function (toggle) {
    toggle.addEventListener('keydown', function (event) {
      if (event.key === ' ' || event.code === 'Space' || event.key === 'Spacebar') {
        event.preventDefault();
        const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle);
        dropdown.toggle();
      }
    });
  });

  // Remove aria-hidden from sr7 overlay layers on /wellness/wellness-wheel/ to allow screen readers to access the content within the layers. The layers are still visually hidden with CSS, but this allows screen reader users to access the content and interact with the buttons within the layers.
  if (window.location.pathname.startsWith('/wellness/wellness-wheel/')) {
    setTimeout(() => {
      document
        .querySelectorAll('.sr7-layer, .sr7-layer.sr7-btn, .sr7-btn.sr7-layer')
        .forEach(function (el) {
          el.removeAttribute('aria-hidden');
        });
    }, 1000);
  }
});
